import { Center } from "native-base";

export default Center;